import FoodWatchItem from './FoodWatchItem';
import './FoodWatchItem.scss';

export default FoodWatchItem;